import React from 'react';
import './styles.scss';

function getStyle(el) {
  return el.currentStyle || window.getComputedStyle(el);
}

const SCROLL_GUTTER = 5;

class Scroller extends React.Component {

  constructor(props) {
    super(props);
    this.state = { active: false, bottom: 50 }
    this.handleClick = this.handleClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.setScrollerReference = this.setScrollerReference.bind(this);
  }

  componentDidMount() {
    this.setScrollerReference();
    this.marginTop = parseInt(getStyle(document.querySelector('.main-wrapper')).marginTop);
    window.addEventListener('scroll', this.handleScroll, false);
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll, false);
  }

  handleScroll(e) {
    if (!this.scrollerReference) {
      this.setScrollerReference();
    }
    if(!this.scrollerReference) return;
    const rect = this.scrollerReference.getBoundingClientRect();
    const footer = document.querySelector('.main-wrapper .footer');
    let bottom = 50;
    if (footer.offsetTop < window.scrollY + window.innerHeight) {
      bottom = (window.scrollY + window.innerHeight) + -footer.offsetTop + 50;
    }
    if (rect.bottom < this.marginTop) {
      this.setState({ active: true, bottom });
    } else if (this.state.active) {
      this.setState({ active: false, bottom });
    }
  }

  handleClick() {
    let offset = this.scrollerReference.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
    window.scroll(0, offset - this.marginTop - SCROLL_GUTTER);
  }

  setScrollerReference() {
    this.scrollerReference = document.querySelector(this.props.scrollerSelector);
  }

  render() {
    return (
      <div className={`scroller ${this.state.active ? 'active' : ''}`} onClick={this.handleClick} style={{bottom:this.state.bottom}}>
        <svg x="0px" y="0px" viewBox="0 0 26.1 26">
          <polygon
            points="24.9,12.9 13,1 12.9,1 12.9,1 1,12.9 4.4,16.3 10.5,10.2 10.5,24.6 15.4,24.6 15.4,10.2 21.5,16.3 " />
        </svg>
      </div>
    )
  }

}

export default Scroller;
